import { render, staticRenderFns } from "./AudienceCreate.vue?vue&type=template&id=5df83b45&scoped=true&"
import script from "./AudienceCreate.vue?vue&type=script&lang=js&"
export * from "./AudienceCreate.vue?vue&type=script&lang=js&"
import style0 from "./AudienceCreate.vue?vue&type=style&index=0&id=5df83b45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df83b45",
  null
  
)

export default component.exports